import { render, staticRenderFns } from "./Dummy.vue?vue&type=template&id=1cf52bee&scoped=true&"
import script from "./Dummy.vue?vue&type=script&lang=js&"
export * from "./Dummy.vue?vue&type=script&lang=js&"
import style0 from "./Dummy.vue?vue&type=style&index=0&id=1cf52bee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf52bee",
  null
  
)

export default component.exports